export default {
    alertsChecked(state) {
        return state.alertsChecked;
    },
    urgentAlertContent(state) {
        return state.urgentAlertContent;
    },
    hasUrgentAlert(state) {
        return !!state.urgentAlertContent;
    },
};
